import { useTheme } from '@mui/material';
import { useFormik } from 'formik';
import { useState } from 'react';
import { VERIFY_FORM_INIT_VALUES } from '../../constants/auth';
import { FormContainer } from '../../containers/FormContainer/FormContainer';
import { Copy } from '../../copy/Copy';
import { useAuth } from '../../hooks/useAuth/useAuth';
import {
  marginTop16Sx,
  buttonSx,
  centerTextSx,
} from '../../styles/Global.style';
import { Form } from '../Form/Form';
import { FormInput } from '../FormInput/FormInput';
import { Button } from '../Button/Button';
import { VERIFY_VALIDATION_SCHEMA } from '../../validation/auth';
import { SendConfirmationCode } from '../SendConfirmationCode/SendConfirmationCode';
import { Text } from '../Text/Text';

export const VerifyUserForm = ({ userEmail, handleVerify }) => {
  const theme = useTheme();
  const { verify } = useAuth();
  const [message, setMessage] = useState();
  const [isError, setIsError] = useState(false);
  const [email, setEmail] = useState(userEmail);

  const handleError = (message) => {
    setIsError(true);
    setMessage(message);
  };

  const onEmailKeyUp = (e) => {
    setEmail(e.target.value);
  };

  const resetError = () => {
    setTimeout(() => {
      setMessage('');
      setIsError(false);
    }, 3000);
  };

  const formik = useFormik({
    initialValues: VERIFY_FORM_INIT_VALUES,
    validationSchema: VERIFY_VALIDATION_SCHEMA,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (val) => {
      try {
        await verify(
          userEmail ?? val.email.toLowerCase(),
          val.confirmationCode,
        );
        handleVerify();
      } catch (err) {
        handleError(err.message);
      }
    },
  });

  return (
    <FormContainer title={Copy.generate('VerifyUserForm.title')}>
      <Text text={Copy.generate('VerifyUserForm.content')} sx={centerTextSx} />
      <Form formik={formik} isError={isError} message={message}>
        {!userEmail && (
          <FormInput
            inputFor="email"
            formik={formik}
            labelText={Copy.generate('Inputs.email')}
            onKeyUp={onEmailKeyUp}
            inputType="email"
          />
        )}
        <FormInput
          inputFor="confirmationCode"
          formik={formik}
          labelText={Copy.generate('Inputs.confirmationCode')}
          inputType="text"
        />
        <Button
          type="submit"
          fullWidth
          text={Copy.generate('Buttons.send')}
          sx={{ ...buttonSx(theme), ...marginTop16Sx }}
        />
      </Form>

      {!isError && (
        <SendConfirmationCode
          handleError={handleError}
          userEmail={email}
          resetError={resetError}
        />
      )}
    </FormContainer>
  );
};
